module.exports = __webpack_public_path__ + "img/mobile/Background-freespins/backgroundfs@1x.jpg?0.0.53";